import '../../sass/plugins/featured_properties.scss';

$(() => {
  const nextArrow = $('.featured-properties-arrow--next');
  const prevArrow = $('.featured-properties-arrow--prev');
  const $slider = $('.featured-properties-slider');

  $slider.slick({
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    appendDots: $('.featured-properties-dots'),
    nextArrow,
    prevArrow,
    pauseOnHover: true,
    centerPadding: '0px',
  });
  $slider.removeClass('preloaded');
});
